// src/App.js

import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// AuthContext
import { AuthProvider, AuthContext } from "./utils/AuthContext";


import LoginForm from "./components/LoginForm";
import BatchInfo from "./pages/BatchInfo";
import AdminPanel from "./pages/AdminPanel";
import ViewBatches from "./pages/ViewBatches";
import AddBatch from "./pages/AddBatch";
import EditBatch from "./pages/EditBatch";


const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useContext(AuthContext);
  return isAuthenticated ? children : <Navigate to="/" />;
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/admin/login" element={<LoginForm />} />
          <Route path="/batch" element={<BatchInfo />} />

          {/* Protected Admin Routes */}
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            }
          >
            <Route index element={<ViewBatches />} />
            <Route path="batches" element={<ViewBatches />} />
            <Route path="add-batch" element={<AddBatch />} />
            <Route path="edit-batch/:batchNo" element={<EditBatch />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
